<template>
  <edit-modal
    :caption="caption"
    :isActive="isActive">
    <!-- TODO: State is being modified from within the component here -->
    <div class="field">
      <div class="control">
        <input type="text" class="input" v-model="name" placeholder="Voer een naam in voor de nieuwe klant of klantonderdeel">
      </div>
    </div>

    <save-buttons
      @save="save"
      @cancel="cancel"
      :disabled="!valid">
    </save-buttons>
  </edit-modal>
</template>

<script>
import { bus } from '@/main'
import { mapGetters } from 'vuex'
import EditModal from '@/components/modules/EditModal'
import SaveButtons from '@/components/modules/SaveButtons'

export default {
  props: [
    'items'
  ],
  components: {
    EditModal,
    SaveButtons
  },
  data () {
    return {
      id: null,
      name: null,
      item_id: null,
      isActive: false
    }
  },
  computed: {
    ...mapGetters({
      item: 'items/item'
    }),
    caption () {
      return (this.item) ? `${this.item.name} bewerken` : 'Nieuwe klant of klantonderdeel'
    },
    valid () {
      return this.name !== null && this.name.length > 0
    }
  },
  watch: {
    item () {
      if (this.item) {
        this.id = this.item.id
        this.item_id = this.item.item_id
        this.name = this.item.name
      }
    }
  },
  created () {
    let self = this

    // TODO: Replace these global events for local events in component and parent
    bus.$on('createItem', function (payload) {
      self.item_id = (payload.parentId !== null) ? payload.parentId : null
      self.isActive = true
    })

    bus.$on('editItem', function (payload) {
      self.$store.dispatch('items/load', payload.itemId)
      self.isActive = true
    })
  },
  methods: {
    cancel () {
      this.$store.commit('items/RESET')
      this.close()
    },
    save () {
      let data = {
        id: this.id,
        item_id: this.item_id,
        name: this.name
      }

      this.$store.dispatch('items/save', data)
      this.close()
    },
    close () {
      this.id = this.item_id = this.name = null
      this.isActive = false
    }
  }
}
</script>
